import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface ReactCommentProps {
    text: string;
}

class ReactComment extends React.Component<ReactCommentProps, {}> {
    componentDidMount() {
        const element = ReactDOM.findDOMNode(this) as Element;
        ReactDOM.unmountComponentAtNode(element);

        // OutlookWeb:54527
        // tslint:disable-next-line:no-inner-html
        element.outerHTML = this.createComment();
    }

    createComment() {
        return `<!--${this.props.text}-->`;
    }

    render() {
        return <div />;
    }
}

export default ReactComment;
